export const getFormattedDate = (date, seperator = "-") => {
  // console.log({date, seperator})
  if(!date) if(seperator === "/" ) return "---"; else date = new Date()
  var today = new Date(date);
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();

  if (dd < 10) {
    dd = "0" + dd;
  }

  if (mm < 10) {
    mm = "0" + mm;
  }

  return (seperator === "/") ? dd + "/" + mm + "/" + yyyy : yyyy + "-" + mm + "-" + dd;
};

//2024-06-07 to 2024-06
export const formatDateToYYYYMM = (date = new Date().getFullYear() + "-" + (new Date().getMonth() + 1)) => {
  if (!date) return "";
  const [year, month] = date.split('-');
  return `${year}-${parseInt(month) > 9 ? month : ("0"+ month)}`;
}

export const convertSlashToDash = (dateStr) => {
  return dateStr?.replace(/\//g, "-");
};


//to "January-2024"
export const getFormattedMonthYear = (date = new Date()) => {
  const options = { year: 'numeric', month: 'long' };
  return new Date(date).toLocaleDateString('en-US', options);
};

//January-2024 to "2024-01"
export const formatToYYYYMM = (date) => {
  const [monthStr, yearStr] = date.split(' ');
  const month = ("0" + (new Date(Date.parse(monthStr + " 1, 2024")).getMonth() + 1)).slice(-2);
  return `${yearStr}-${month}`;
};

//"2024-01" to January-2024
export const formatMonthYear = (monthYear) => {
  const [year, month] = monthYear.split('-');
  const date = new Date(year, month - 1); // month is 0-indexed
  const monthName = date.toLocaleString('default', { month: 'long' });
  return `${monthName}-${year}`;
};

//"2024-06-05T07:54:58.748Z" to 05-06-2024
export const formatDate = (dateString) => {
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
  const date = new Date(dateString);
  const formattedDate = date.toLocaleDateString('en-GB', options).split('/').join('-');
  return formattedDate;
};

export const formattedDate = (dateString) => {
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
  const date = new Date(dateString);
  const formattedDate = date.toLocaleDateString('en-GB', options).split('/').join('/');
  return formattedDate;
};

export const convertToIndianTimezone = (utcDate) => {
  const indianTimeZone = 'Asia/Kolkata';
  const options = {
    timeZone: indianTimeZone,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  };

  const indianDate = new Date(utcDate).toLocaleDateString('en-IN', options);
  return indianDate.replace(/\//g, '-');;
};

export const convertToIndianTimezoneAndGetDate = (utcDate, time = false) => {
  const resultantDate = convertToIndianTimezone(utcDate);
  if(resultantDate==="Invalid Date") return "---"
  return time ? resultantDate: resultantDate.substring(0, 10)
};

export const exportFile = async (url, filename) => {
  const data = await fetch(url)
  const blob = await data.blob()
  const objectUrl = URL.createObjectURL(blob)

  const link = document.createElement('a')

  link.setAttribute('href', objectUrl)
  link.setAttribute('download', filename)
  link.style.display = 'none'

  document.body.appendChild(link)

  link.click()

  document.body.removeChild(link)
};

export function titleCase(str) {
  if (!str) return "";

  const lowerStr = String(str).toLowerCase();
  
  if (lowerStr === "grn pending" || lowerStr === "grnpending") {
    return "GRN Pending";
  }

  return lowerStr
    .split(' ')
    .map((word) => {
      if (word === "grn") {
        return "GRN";
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
}

export function getFileTypeFromExtension(fileExtension) {
  const extensionToMIME = {
      '.jpg': 'image/jpeg',
      '.jpeg': 'image/jpeg',
      '.png': 'image/png',
      '.gif': 'image/gif',
      '.pdf': 'application/pdf',
      '.doc': 'application/msword',
      '.docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      // Add more extensions and their corresponding MIME types as needed
  };

  // Remove leading dot (.) if present in the extension
  if (fileExtension.startsWith('.')) {
      fileExtension = fileExtension.slice(1);
  }

  return extensionToMIME[fileExtension] || 'application/octet-stream'; // Default to 'application/octet-stream' if extension is unknown
}

export function getRandomColor() {
  var letters = '0123456789ABCDEF';
  var color = '#';
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

export const tyrePositionsOptions = [
  "FL",
  "FR",
  "DLO",
  "DLI",
  "DRO",
  "DRI",
  "DLO1",
  "DLI1",
  "DRO1",
  "DRI1",
  "DLO2",
  "DLI2",
  "DRO2",
  "DRI2",
  "TLO1",
  "TLI1",
  "TRO1",
  "TRI1",
  "TLO2",
  "TLI2",
  "TRO2",
  "TRI2",
  "TLO3",
  "TLI3",
  "TRO3",
  "TRI3",
  "STP",
  "STP1",
  "STP2",
  "FL1",
  "FR1",
  "FL2",
  "FR2",
  "LLO",
  "LLI",
  "LRO",
  "LRI",
  "LL1",
  "LR1",
  "RLO",
  "RLI",
  "RRO",
  "RRI",
  "RL1",
  "RL2",
  "RR1",
  "RR2",
  "TL1",
  "TL2",
  "TR1",
  "TR2",
  "LL2",
  "LR2",
  "RL",
  "RR",
]

export default getFormattedDate;
